import { render, staticRenderFns } from "./registerAndInfo.vue?vue&type=template&id=676e65a2&scoped=true"
import script from "./registerAndInfo.vue?vue&type=script&lang=js"
export * from "./registerAndInfo.vue?vue&type=script&lang=js"
import style0 from "./registerAndInfo.vue?vue&type=style&index=0&id=676e65a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e65a2",
  null
  
)

export default component.exports